import { createSelector } from "reselect"

import { IUserInfo } from "."

const getTimeZone = (state: IUserInfo): string => state.timeZone

const getCulture = (state: IUserInfo): string => state.culture

export const getTimeZoneForLuxon = createSelector(
    [getTimeZone],
    (timeZone): string => (timeZone.length > 0 ? timeZone : "default"),
)

// fr is for european in the Product-Fields component
export const getLocale = createSelector([getCulture], (culture): "en" | "fr" =>
    culture.includes("US") ? "en" : "fr",
)
